import * as actionType from "./action";

const initialState = {
  user: null,
  role: null,
  token: null,
  emailVerified: true,
  userEntry: [false, "login"],
  stationId: null,
  jwtUpdatedAt: 0,
  userHaveReset: false,
  emailVerificationDismissed: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.LOGIN:
      return {
        ...state,
        ...action.payload,
        emailVerified: action.payload.emailVerified !== false,
        userEntry:
          state.userEntry?.[0] && action.payload.isGuestHydration === true
            ? state.userEntry
            : [false, "login"],
        userHaveReset: false,
        emailVerificationDismissed: false,
      };
    case actionType.UPDATE_USER:
      return {
        ...state,
        user: { ...(state.user || {}), ...action.payload },
      };
    case actionType.LOGOUT:
      return {
        ...state,
        stationId: null,
        user: null,
        role: null,
        emailVerified: true,
        userHaveReset: false,
        emailVerificationDismissed: false,
        jwtUpdatedAt: Date.now(),
      };
    case actionType.JWT_UPDATED:
      return {
        ...state,
        jwtUpdatedAt: Date.now(),
      };
    case actionType.UPDATE_STATION_ID:
      return {
        ...state,
        stationId: action.payload,
      };
    case actionType.USER_ENTRY:
      return {
        ...state,
        userEntry: action.payload,
      };
    case actionType.VERIFIED_EMAIL:
      if (action.payload) {
        return {
          ...state,
          emailVerified: false,
          userHaveReset: action.payload,
          emailVerificationDismissed: false,
          userEntry: [false, "login"],
        };
      }
      return {
        ...state,
        emailVerified: true,
        userHaveReset: false,
        emailVerificationDismissed: false,
        userEntry: [false, "login"],
      };
    case actionType.SET_EMAIL_VERIFICATION_DISMISSED:
      return {
        ...state,
        emailVerificationDismissed: action.payload,
      };
    case actionType.SET_TEMP_ADDRESS:
      return {
        ...state,
        stationId: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
